<template>
  <my-button style="padding: 0px;">
    <slot></slot>
  </my-button>
</template>

<script>
export default {
  name: 'my-icon'
}
</script>

<style></style>
